export function ListMonitoringBioSuisse() {
    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
            <table id="users-table" className="w-full border-collapse text-text-md min-w-[1320px]">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Sede</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Cliente</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Certificato</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Scadenza</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Visita</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prot. Invio Doc.</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prot. Richiesta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prot. Risposta</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prodotti Certificati</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Esito</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note Esito</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Condizioni</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Note Condizioni</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={15} className="px-3 py-3 text-left text-neutral-500 bg-white">
                            Nessun risultato disponibile per il monitoraggio BioSuisse
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}